import { render } from "./GameListPage.vue?vue&type=template&id=1b3874ea&ts=true"
import script from "./GameListPage.vue?vue&type=script&lang=ts"
export * from "./GameListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__